<template>
  <div class="is-marginless is-paddingless section section-details" v-if="produit">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ $t('produitDivers.title', { libelle: produit.libelle })}}
            <b-tag v-if="!produit.actif"
              type="has-background-subMenu"
              class="has-text-white mgl-5px">
              {{$t('catalogue.etatProduit')}}
            </b-tag>
          </h1>
          <app-breadcrumb :breadcrumb="breadcrumb"></app-breadcrumb>
        </div>
        <div class="column is-narrow">
          <div class="buttons">
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :disabled="produitDiversFromHolding"
              :permission="permCatalogue.maj"
              :actions="actionSecondary"
              @click="() => {
                $router.push({ name: 'm.bodac.catalogue-editionDivers',
                  params: { produitId: $route.params.id,
                  isFromCatalogueAchat: $route.params.isFromCatalogueAchat}});
              }">
                {{ $t('detail.buttons.edit') }}&nbsp;
            </dropdownButton>
            <button class="button"
                    :class="[{'button-access-no-permission' :
            produitDiversFromHolding},
            { 'pointer-events-none' : produitDiversFromHolding}]"
                    @click="checkPermissions(permCatalogue.maj) ?
                      popUpCopy = true : showPopUpPermission()">
              <b-icon icon="file-multiple" type="is-default"></b-icon>
            </button>
            <b-dropdown class="button is-bottom-left has-text-left is-relative">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item class="pdl-20px">
                <p class="has-text-icon-more is-size-7">
                  {{$t('catalogue.newProduct.titleAccesRapide')}}
                </p>
              </b-dropdown-item>
              <b-dropdown-item class="is-paddingless"
                               v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
                <router-link-blank :to="{ name: accesRapide.name,
                                      params: accesRapide.params}"
                                   class="pdt-5px pdb-5px"
                                   classMessage="has-text-default is-size-6 is-block
                                     mgl-20px mgr-20px"
                                   classComposant="noTextDecoration"
                                   :message="accesRapide.libelle">
                </router-link-blank>
              </b-dropdown-item>
            </b-dropdown>
            <piece-jointe-button :class="[{'button-access-no-permission' :
              produitDiversFromHolding},
              { 'pointer-events-none' : produitDiversFromHolding}]"
              class="mgr-2"
              :perm="permCatalogue.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'Produit'}"
              @click="activeTab = 'Produit'">
            {{ $t('produitLocation.produit') }}
          </li>
          <li v-if="!$route.params.isFromCatalogueAchat"
            :class="{'is-active': activeTab === 'TabListeLignesCommande'}"
            @click="activeTab = 'TabListeLignesCommande'">
            {{ $t('catalogue.newProduct.tab.ventes') }}
          </li>
          <li :class="{'is-active': activeTab === 'demandeInterventionType'}"
              @click="activeTab = 'demandeInterventionType'">
            {{ $t('catalogue.newProduct.tab.demandeInterventionType') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="columns">
      <div class="column is-10">
        <component :is="activeTab"
          :produit="produit"
          :isDisabled="true"
          :type-location-or-divers="true"
          :permissions="permCatalogue"
          detail/>
      </div>
      <div class="column is-2">
        <div class="sticky-20px">
          <information-create-update-user :data="userInfoData"></information-create-update-user>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpArchivage"
             has-modal-card
             class="modal">
      <PopUpPrevention
        :messHeader="this.$t(baseTradArchiveComputed + '.title')"
        :cancel="this.$t(baseTradArchiveComputed + '.no')"
        :validate="this.$t(baseTradArchiveComputed + '.yes')"
        @no="popUpArchivage = false"
        @yes="archiverProduit"/>
    </b-modal>
    <b-modal v-model="popUpCopy" has-modal-card class="modal">
      <PopUpPrevention
        :messHeader="$t('catalogue.popUpPreventionCopy.message')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="copy"
        @no="popUpCopy = false"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import breadcrumb from '@/components/general/breadcrumb';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import Produit from '@/components/catalogue/detail/produitDivers/produit';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import inProgress from '@/services/general/inProgress';
import { get, archiver, copieAsync } from '@/api/produit/produitDivers';
import { SENS_VENTE } from '@/configuration/devisConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import schemaComptable from '@/components/general/schemaComptable';
import PopUpPrevention from '@/components/general/popUpPrevention';
import TabListeLignesCommande from '@/components/bodac/lignesCommande/tabListeLignesCommande';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import detailCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/detailCompteAnalytique';
import detailEditionDcf from '@/components/catalogue/produitGeneral/editionDcf/c_editionDcf';
import detailProduitOpposeLie from '@/components/catalogue/produitGeneral/produitOpposeLie/detailProduitOpposeLie';
import { siteHasHolding, getIdSocieteHolding } from '@/services/general/holding';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import getUserInfoData from '@/services/general/getUserInfoData';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'DetailProduitDivers',
  data() {
    return {
      activeTab: 'Produit',
      produit: null,
      permCatalogue: CATALOGUE,
      popUpArchivage: false,
      popUpCopy: false,
    };
  },
  components: {
    dropdownButton,
    appBreadcrumb: breadcrumb,
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    routerLinkBlank,
    Produit,
    schemaComptable,
    PopUpPrevention,
    TabListeLignesCommande,
    detailCompteAnalytique,
    detailEditionDcf,
    detailProduitOpposeLie,
    pieceJointeButton,
    demandeInterventionType,
    InformationCreateUpdateUser,
  },
  methods: {
    ...permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    async archiverProduit() {
      this.popUpArchivage = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.produit.id, this.produit.actif);
        messageSucces(this.$t(this.baseTradArchiveComputed + '.produitDiversArchiver'));
        loadingComponent.close();
        this.produit.actif = !this.produit.actif;
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async copy() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const retour = await copieAsync(this.produit.id, this.$t('catalogue.labelCopy'));
        messageSucces(this.$t('catalogue.popUpPreventionCopy.success'));
        loadingComponent.close();
        this.$router.push({
          name: 'm.bodac.catalogue-editionDivers',
          params: {
            produitId: retour.data.result.id,
            isFromCatalogueAchat: this.$route.params.isFromCatalogueAchat,
          },
        });
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    produitWithHolding() {
      return (siteHasHolding() && this.produit
        && this.produit.supportCommercial.societeId !== this.societeActiveId);
    },
    hasHolding() {
      return siteHasHolding();
    },
    produitDiversFromHolding() {
      return (siteHasHolding() && this.produit
        && (this.societeActiveId !== this.produit.supportCommercial.societeId
        || this.produit.supportCommercial.societeId !== getIdSocieteHolding()));
    },
    baseTradArchiveComputed() {
      if (this.produit && this.produit.actif) return 'produitDivers.archivage';
      return 'produitDivers.desarchivage';
    },
    breadcrumb() {
      if (this.$route.params.isFromCatalogueAchat) {
        return [
          { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
          { title: this.$i18n.t('listeProduitAchat.breadcrumb.liste'), route: { name: 'l.bodac.catalogue-produitAchat' }, isActive: false },
          { title: this.$i18n.t('produitDivers.title', { libelle: this.produit.libelle }), route: { name: '' }, isActive: true },
        ];
      }
      return [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('catalogue.titleProduit'), route: { name: 'l.bodac.catalogue' }, isActive: false },
        { title: this.$i18n.t('produitDivers.title', { libelle: this.produit.libelle }), route: { name: '' }, isActive: true },
      ];
    },
    genererAllAccesRapide() {
      return [
        { name: 'l.bodac.commandes-liste-par-produit', params: { sens: SENS_VENTE, produitId: this.produit.id }, libelle: this.$t('catalogue.newProduct.voirCommandes') },
        { name: 'l.bodac.factures-par-produit', params: { sens: SENS_VENTE, produitId: this.produit.id }, libelle: this.$t('catalogue.newProduct.voirFactures') },
        { name: 'l.bodac.commandes-lignesCmd-par-produit', params: { sens: SENS_VENTE, produitId: this.produit.id, typeLocationOrDivers: true }, libelle: this.$t('catalogue.newProduct.voirLignesCommande') },
      ];
    },
    getLibelleSociete() {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === this.produit.supportCommercial.societeId;
      });
      if (societe) return societe.libelle;
      return '';
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t(this.baseTradArchiveComputed + '.action'),
          action: () => { this.popUpArchivage = true; },
          actionpermission: CATALOGUE.supprimer,
        },
        {
          label: this.$t('detail.buttons.delete'),
          action: () => { this.inProgress(); },
          actionpermission: CATALOGUE.supprimer,
        },
      ];

      return actions;
    },
    userInfoData() {
      return getUserInfoData(this.produit, this.produit?.produitDivers);
    },
  },
  async beforeMount() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.produit = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentContext({ module: 'ProduitDivers' });
      await this.setAttachmentElementId({ id: this.produit.id });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.produit.libelle }));
  },
};
</script>

<style scoped>

</style>
